import React, { Component } from 'react'
import { Dropdown, Form, Header, Icon, Segment } from 'semantic-ui-react'
import DatePicker from './DatePicker'
import moment from 'moment'

class InventoryBlock extends Component {
    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
    }
    onChange(e, { name, value }) {
        const { onChange, block } = this.props
        onChange(e, { ...block, [name]: value })
    }
    render() {
        const { block } = this.props
        const colorOptions = [
            {
                key: 'red',
                value: 'red',
                text: 'Red',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="red" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Red" />
                    </div>
                ),
            },
            {
                key: 'orange',
                value: 'orange',
                text: 'Orange',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="orange" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Orange" />
                    </div>
                ),
            },
            {
                key: 'yellow',
                value: 'yellow',
                text: 'Yellow',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="yellow" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Yellow" />
                    </div>
                ),
            },
            {
                key: 'green',
                value: 'green',
                text: 'Green',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="green" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Green" />
                    </div>
                ),
            },
            {
                key: 'blue',
                value: 'blue',
                text: 'Blue',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="blue" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Blue" />
                    </div>
                ),
            },
            {
                key: 'purple',
                value: 'purple',
                text: 'Purple',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="purple" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Purple" />
                    </div>
                ),
            },
            {
                key: 'brown',
                value: 'brown',
                text: 'Brown',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="brown" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Brown" />
                    </div>
                ),
            },
            {
                key: 'grey',
                value: 'grey',
                text: 'Grey',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="grey" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Grey" />
                    </div>
                ),
            },
        ]
        console.log(block, block.tagColor)
        return (
            <Segment>
                <Form>
                    <Form.Field>
                        <label>Hang Tag Color</label>
                        <Dropdown name="tagColor" fluid selection onChange={this.onChange} value={block.tagColor} options={colorOptions} />
                    </Form.Field>
                    <Form.Input label="Name" placeholder="Name" name="name" value={block.name} onChange={this.onChange} />
                    {/* <Form.Group> */}
                    <Form.Field>
                        <label>From</label>
                        <DatePicker
                            name="startDate"
                            placeholderText="From"
                            selected={block.startDate ? moment.utc(block.startDate) : null}
                            onChange={this.onChange}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            timeIntervals={15}
                            showTimeSelect
                            dateFormat="MMMM Do YYYY, h:mm a"
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>To</label>
                        <DatePicker
                            name="endDate"
                            placeholderText="To"
                            selected={block.endDate ? moment.utc(block.endDate) : null}
                            onChange={this.onChange}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            timeIntervals={15}
                            showTimeSelect
                            dateFormat="MMMM Do YYYY, h:mm a"
                        />
                    </Form.Field>
                    {/* </Form.Group> */}
                </Form>
            </Segment>
        )
    }
}

InventoryBlock.propTypes = {}

export default InventoryBlock
